module.exports = __webpack_public_path__ + "static/media/house-white.6ee7bf49.png";